import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import flowAnalysis from './modules/flowAnalysis' // 引入新模块
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    flowAnalysis, // 添加模块
  },
  getters,
  state: {
    // 存储当前激活的标签页列表
    activeTabs: [{
      path: '/home',
      name: '首页',
      closable: false
    }],
    // 当前激活的标签页
    activeTab: null,
    // analysisLoading: false // 全局加载状态
  },
  mutations: {
    // 添加一个新的标签页
    addTab(state, tab) {
      // console.log(state);
      // console.log(tab);
      // 如果标签页不存在于列表中，则添加
      if (!state.activeTabs.some(t => t.path === tab.path)) {
        state.activeTabs.push(tab);
      }
      // 设置当前激活的标签页
      state.activeTab = tab.path;
    },
    // 关闭一个标签页
    closeTab(state, path) {
      // 过滤掉要关闭的标签页
      state.activeTabs = state.activeTabs.filter(t => t.path !== path);
      // 如果关闭的是当前激活的标签页
      if (state.activeTab === path) {
        // 设置新的激活标签页为列表中的最后一个，如果列表为空则设为 null
        state.activeTab = state.activeTabs.length > 0 ? state.activeTabs[state.activeTabs.length - 1].path : null;
      }
    },
    // 设置当前激活的标签页
    setActiveTab(state, path) {
      state.activeTab = path;
    },
    // setAnalysisLoading(state, status) {
    //   state.analysisLoading = status
    // }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js